import {useEffect, useMemo, useState} from "react";
import store from 'storejs';
import {fetchLecturersList} from "../Functions/fetchLecturersList";
import {useDispatch, useSelector} from "react-redux";
import {selectLecturers, selectLoading} from "../Reducers/LecturersReducer";

export const useFetchLecturers = () => {
    const dispatch = useDispatch()
    const lecturers = useSelector(selectLecturers)
    const loading = useSelector(selectLoading)

    const lecturersLocal = useMemo(() => store('lecturers')??[], []);

    useEffect(() => {
        dispatch(fetchLecturersList());
    }, [dispatch])

    useEffect(()=>{
        store({lecturers});
    },[lecturers])

    return {
        loading: loading,
        lecturers
    }
}
